import {createSlice} from '@reduxjs/toolkit';

function assignApiUrl(){
    if(window.location.href.indexOf("localhost") != -1){
    //    return 'http://localhost:8080/IntelAgentApi/'
    // return  'https://dev.intelagentservices.com.au/api/'
        return  'https://www.intelagentservices.com.au/api/'
    }else if(window.location.href.indexOf("www") != -1){
        return 'https://www.intelagentservices.com.au/api/'
    }else if(window.location.href.indexOf("dev") != -1){
       return  'https://dev.intelagentservices.com.au/api/'
    }
}

export const apiPath = createSlice({
    name: 'apiUrlPath',
    initialState: {
        value: assignApiUrl(),
    },
    reducers: {
        // increment: (state) => {
        //     // Redux Toolkit allows us to write "mutating" logic in reducers. It
        //     // doesn't actually mutate the state because it uses the Immer library,
        //     // which detects changes to a "draft state" and produces a brand new
        //     // immutable state based off those changes.
        //     // Also, no return statement is required from these functions.
        //     state.value += 1
        //   },
        //   decrement: (state) => {
        //     state.value -= 1
        //   },
        //   incrementByAmount: (state, action) => {
        //     state.value += action.payload
        //   },
    },
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = apiPath.actions

export default apiPath.reducer